import Team from '../components/team.svelte'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

const { $ } = window
const $body = $(document.body)

export default {
   init() {
      gsap.registerPlugin(ScrollTrigger)

      let $teamWrap = $('#team-wrap')
      if ($teamWrap.length) {
         new Team({
            target: $teamWrap[0],
         })
      }

      if (document.querySelector('.hero-content h2')) {
         let tl = gsap.timeline()
         gsap.set('.hero-content h2', { x: -32 })
         gsap.set('.filter-bar', { x: -16 })
         tl.to('.hero-content h2', {
            opacity: 1,
            x: 0,
            ease: 'power1.out',
            duration: 0.65,
         })
         tl.to(
            '.hero-img',
            { opacity: 1, ease: 'power1.out', duration: 0.65 },
            '-=0.65'
         )
         tl.to(
            '.filter-bar',
            { opacity: 1, x: 0, y: 0, ease: 'power1.out', duration: 0.65 },
            '-=0.65'
         )
      }

		//! was causing issues with "overlapping"/"cutoff"
		if ($body.hasClass('single-team') || $body.hasClass('single-leadership')) {
         // relationshipSlider()
         // window.onresize = () => {
         //    relationshipSlider()
         // }
      }
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}

function relationshipSlider() {
   const relationSlides = document.querySelectorAll('.relation-card')
   function myFunction(x) {
      if (x.matches) {
         $('.relationships-card-wrap').slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            vertical: true,
            // verticalSwiping: true,
				touchMove:false,
            nextArrow:
               '<button type="button" class="slick-next btn outlined">View More Relationships</button>',
            prevArrow:
               '<button type="button" class="slick-next d-none">Previous</button>',
         })
      } else {
         $('.relationships-card-wrap.slick-initialized').slick('unslick')
      }
   }

   var x = window.matchMedia('(max-width: 576px)')
   myFunction(x) // Call listener function at run time
   x.addListener(myFunction) // Attach listener function on state changes
}
